import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

/** Réserve le Pixel Game aux administrateurs et aux testeurs de la bêta. */
@Injectable({ providedIn: 'root' })
export class PixelGameAccessGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean | UrlTree {
    if (!this.authService.isLoggedIn()) return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state?.url ?? '/pixel-game' } });
    const roles = this.authService.getRoles();
    return roles.includes('ADMIN') || roles.includes('GAME_BETA_TESTEUR')
      ? true
      : this.router.createUrlTree(['/access-denied']);
  }
}
